module.exports = __webpack_public_path__ + "media/images/registration-form-cd2435e57a2a27823130e52e9abc37d5.svg";